import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import clamShellManager, { clamShellBasicI } from "../../manager/clamShellManager";
import NormalGameManager from "../../manager/NormalGameManager";
import { clamShellEndInterface, clamShellStartInterface } from "./clamShellConst";
import clamShellExplain from "./clamShellExplain";
import clamShellGameClean from "./clamShellGameClean";
import clamShellGameObj from "./clamShellGameObj";
import clamShellOpen from "./clamShellOpen";

const {ccclass, property} = cc._decorator;

@ccclass
export default class clamShellGame extends cc.Component {

    @property({type:cc.Node,displayName:"center"})
    center:cc.Node = null;

    @property({type:cc.Prefab,displayName:"蚌壳预制体"})
    objPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"objLayout"})
    objLayout:cc.Node = null;

    oneVecAry:cc.Vec2[] = [cc.v2(-237,-352),cc.v2(0,-352),cc.v2(237,-352)];
    twoVecAry:cc.Vec2[] = [cc.v2(-237,-163),cc.v2(0,-163),cc.v2(237,-163)];
    threeVecAry:cc.Vec2[] = [cc.v2(-189,0),cc.v2(189,0)];

    clamShellManager:clamShellManager = null;

    objAry:{startObj:clamShellStartInterface,endObj:clamShellEndInterface}[][] = [];

    vecAry:cc.Vec2[][] = [this.oneVecAry,this.twoVecAry,this.threeVecAry];

    eventPro:number = 0.1;

    private clamShellSaveKey:string = "clam-shell-save-key";

    private clamShellDaySaveKey:string = "clam-shell-dat-save-key";

    onLoad(){
        this.clamShellManager = NormalGameManager._instance.clamShellManager;
    }

    loadSaveclamShell(){
        let g = O1HD.getServices().localStorageSrv.getStorage(this.clamShellSaveKey);
        if(!g || g == ""){
            this.loadclamShellObjs().then();
            this.checkDayIsVaild();
        }else{
            if(this.checkDayIsVaild()){
                this.objAry = JSON.parse(g)
                this.loadSaveLayoutObj();
            }else{
                this.loadclamShellObjs().then();
            }
        }
    }

    checkDayIsVaild(){
        let isVaild = O1HD.getServices().localStorageSrv.getStorage(this.clamShellDaySaveKey) == data_control.getCurrDateDayString();
        if(!isVaild){
            O1HD.getServices().localStorageSrv.setStorage(this.clamShellDaySaveKey,data_control.getCurrDateDayString());
        }
        return isVaild;
    }

    start(){
        this.loadGamble().then();
    }

    async loadGamble(){
        this.loadSaveclamShell();
    }

    // 4 选 3
    // 3 选 3
    // 3 选 2
    // 2 选 2

    async loadclamShellObjs(){
        this.loadLayoutObj();
        // await this.loadOneLayoutObj();
        // await this.loadTwoLayoutObj();
        // await this.loadThreeLayoutObj();
        // await this.loadEndLayoutObj();
    }

    //出现过的素材id
    ariseMaterialIds:string[] = [];

    loadSaveLayoutObj(){
        let objAry:{startObj:clamShellStartInterface,endObj:clamShellEndInterface}[][] = this.objAry;
        for(let i = 0;i<objAry.length;i++){
            let o = objAry[i];
            for(let j = 0;j<o.length;j++){
                let data = objAry[i][j];
                if(data){
                    let objNode:cc.Node = cc.instantiate(this.objPrefab);
                    let os = objNode.getComponent(clamShellGameObj);
                    let isHaveBiao:boolean = true;
                    // if(i < 2){
                    //     isHaveBiao = false;
                    // }
                    os.bindDate(data.startObj,data.endObj,this,isHaveBiao);
                    let vec2 = this.vecAry[i][j];
                    objNode.setPosition(vec2);
                    objNode.setParent(this.objLayout);
                }
            }
        }
    }

    spliceOneSaveObj(obj:cc.Node){
        if(obj && obj.isValid){
            let os = obj.getComponent(clamShellGameObj);
            let startData = os.startData;
            let endData = os.endData;

            for(let i = 0;i<this.objAry.length;i++){
                let a = this.objAry[i];
                for(let j =0;j<a.length;j++){
                   let b = a[j];
                    if(JSON.stringify(b.startObj) == JSON.stringify(startData) && JSON.stringify(b.endObj) == JSON.stringify(endData)){
                        a.splice(j,1);
                    }
                }
            }
        }
        this.writeOneSaveObj();
    }

    writeOneSaveObj(){
        O1HD.getServices().localStorageSrv.setStorage(this.clamShellSaveKey,JSON.stringify(this.objAry));
    }

    async loadLayoutObj(){
        let createCountAry:number[] = [3,3,2];
        for(let i =0;i<createCountAry.length;i++){
            let objAry:clamShellBasicI[] = this.clamShellManager.clamShellStartMap[i + 1];
            let createCount:number = createCountAry[i];
            let indexAry:number[] = [];
            this.objAry[i] = [];
            for(let j = 0;j<createCount;j++){
                let randIndex:number = Math.floor(Math.random()*objAry.length);
                while(indexAry.includes(randIndex)){
                    randIndex = Math.floor(Math.random()*objAry.length);
                }
                indexAry.push(randIndex);
                let obj = data_control.getRandItemOfArray(objAry[randIndex].infoArray);
                let objNode:cc.Node = cc.instantiate(this.objPrefab);
                let os = objNode.getComponent(clamShellGameObj);
                let endObj = this.clamShellManager.getOneTypeEnd(obj.id);
                let startObj:clamShellStartInterface = {
                    id: obj.id,
                    icon: objAry[randIndex].icon,
                    gear: i+1,
                    weight: obj.weight,
                    explain: obj.explain,
                    price: obj.price,
                    bindBackId:obj.bindBackId
                }
                let isHaveBiao:boolean = true;
                // if(i < 2){
                //     isHaveBiao = false;
                // }
                os.bindDate(startObj,endObj,this,isHaveBiao);
                this.objAry[i][j] = <{startObj:clamShellStartInterface,endObj:clamShellEndInterface}>{};
                this.objAry[i][j].startObj = startObj;
                this.objAry[i][j].endObj = endObj;
                let vec2 = this.vecAry[i][j];
                objNode.setPosition(vec2);
                objNode.setParent(this.objLayout);
            }
        }
        this.writeOneSaveObj();
    }

    @property({type:cc.Prefab,displayName:"开贝壳预制体"})
    cutPrefab:cc.Prefab = null;

    cutPage:cc.Node = null;

    //开始锯某个木头
    startCutObj(obj:cc.Node){
        let cutNode:cc.Node = cc.instantiate(this.cutPrefab);
        let cs = cutNode.getComponent(clamShellOpen);
        cs.bindNode(obj,this);
        cutNode.setParent(this.node);
    }

    @property({type:cc.Prefab,displayName:"描述界面"})
    explainPrefab:cc.Prefab = null;

    startExplain(objNode:cc.Node){
        let explainPage:cc.Node = cc.instantiate(this.explainPrefab);
        let es = explainPage.getComponent(clamShellExplain);
        es.bindData(objNode,this);
        explainPage.setParent(this.node);
    }

    /**
     * 关闭
     */
    onBtnClose(){
        this.node.removeFromParent();
        this.node.destroy();
    }

    onBtnStock(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.objLayout.destroyAllChildren();
            this.objLayout.removeAllChildren();
            this.loadclamShellObjs();
        },()=>{

        },null,"开贝壳模式重新进货");
    }

    oneNodeBack(obj:cc.Node){
        obj.setParent(this.objLayout);
        obj.setPosition(obj.getComponent(clamShellGameObj).initPos);
    }

}






